export function regenerateIdempotencyKey(form) {
	$(form).find('.idempotency-key-input').val(crypto.randomUUID().toString());
}

$('form:has(.idempotency-key-input)').on('reset', function() {
	regenerateIdempotencyKey(this);
});